module.exports = {
  icons: {
    '01d': 'wi-day-sunny',
    '02d': 'wi-day-cloudy',
    '03d': 'wi-cloudy',
    '04d': 'wi-cloudy',
    '09d': 'wi-showers',
    '10d': 'wi-day-rain',
    '11d': 'wi-day-thunderstorm',
    '13d': 'wi-day-snow-thunderstorm',
    '50d': 'wi-fog',
    '01n': 'wi-night-clear',
    '02n': 'wi-night-alt-cloudy',
    '03n': 'wi-cloudy',
    '04n': 'wi-cloudy',
    '09n': 'wi-showers',
    '10n': 'wi-night-rain',
    '11n': 'wi-night-thunderstorm',
    '13n': 'wi-night-snow-thunderstorm',
    '50n': 'wi-fog',
  },
};
